import { render, staticRenderFns } from "./DropdownIcon.vue?vue&type=template&id=415f3ea0"
import script from "./DropdownIcon.vue?vue&type=script&lang=js"
export * from "./DropdownIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports